namespace Nobox.Web.Modules.Administration.Tenant {
    export interface Subscribe {
        Level?: string;
        Data?: number;
    }
}
